export const tabbarHeight = 48;
